import { createGlobalStyle, css } from 'styled-components';

import { mq } from './grid';

const ContentHubCSS = createGlobalStyle`
  *[data-id='content-hub-card-content'] {
    padding: 0 15px;
  }

  div[data-module-name='CONTENT_HUB_HERO'] {
    margin-bottom: 0px;
    background: white !important;
  }

  div[data-module-name='CONTENT_HUB_HERO'] > div {
    padding-bottom: 10px;
    min-height: auto;
    max-width: 1165px;
  
    @media (${mq.lgDown}) {
      max-width: 935px;
    }

    @media (${mq.mdDown}) {
      max-width: 720px;
      padding-left: 12.5px;
      padding-right: 12.5px;
      overflow: visible;
    }

    @media (${mq.smDown}) {
      max-width: calc(100% - 100px);
      padding-left: 12.5px;
      padding-right: 12.5px;
    }

    @media (${mq.xs}) {
        max-width: 100%;
    }
  }

  div[data-module-name='CONTENT_HUB_HERO'] + div[data-module-name='CONTAINER_LARGE_B'] {
    padding-top: 25px;
    background: white;
     @media (${(props) => props.theme.header.mobileSwitch}) {
      padding-top: 0px;
     }
  }
  
  div[data-module-name='CONTENT_HUB_TEASER'] {
    display: inherit;
  }

  div[data-module-name='CONTENT_HUB_TEASER'] div[data-module-name='CONTAINER_LARGE_B'] > div {
    padding-top: 0px;
    background: white !important;
  }

  div[data-module-name='CONTENT_HUB_TEASER'] div[data-module-name='CONTAINER_LARGE_B'] {
    h2, h3, h4, h5, h6 { 
      color: ${(props) => props.theme.color.primary800} !important;
      text-align: right;
      width: 100%;
      padding-left: 30px;
    }
    p, li, ul, ol, span {
     color: ${(props) => props.theme.color.gray600} !important;
    }
    p {
      padding-right: 30px;
    }
  }


 h5 {
    text-align: ${({ style }) =>
      style === 'CONTENT_HUB' ? 'right' : 'inherit'};
    width: ${({ style }) => (style === 'CONTENT_HUB' ? '100%' : 'inherit')};
 }

${({ style }) =>
  style === 'CONTENT_HUB' &&
  css`
    div[data-module-name='CONTENT_HUB_HERO']
      + div[data-module-name='CONTAINER_LARGE_B']
      > div {
      padding-top: 10px;
      @media (${(props) => props.theme.header.mobileSwitch}) {
        padding-top: 0px;
        margin-top: -12.5px;
      }
    }
  `}

   @media (${(props) => props.theme.header.mobileSwitch}) {
    h5 {
        text-align: ${({ style }) =>
          style === 'CONTENT_HUB' ? 'left' : 'inherit'};
    }
  
    div[data-module-name='CONTENT_HUB_TEASER'] div[data-module-name='CONTAINER_LARGE_B'] {
      padding-bottom: 25px;
      background: white;

      h2, h3, h4, h5, h6 {
        text-align: inherit;
        padding-left: 0px;
      }
      p {
        padding-right: 0px;
      }
    }

    div[data-module-name='CONTENT_HUB_TEASER'] div[data-module-name='CONTAINER_LARGE_B'] > div {
     padding-top: 0px;
     padding-bottom: 0px;
    }
  }
`;

export default ContentHubCSS;
